import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

import { CatalogAdjustmentType } from "@/pages/configuration/models/CatalogAdjustmentType";

type Props = {
	setSelectedRowData: (adjustmentType: CatalogAdjustmentType) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	handleNewType: () => void;
	editAdjustmentType: (data: CatalogAdjustmentType) => void;
};
export const useAdjustmentTypeOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
	handleNewType,
	editAdjustmentType,
}: Props) => {
	const getMenuOptions = (data: CatalogAdjustmentType) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Adj. Type",
				key: "new_adjustment_type",
				onClick: () => {
					handleNewType();
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Adj. Type",
					key: "edit_adjustment_type",
					onClick: () => {
						editAdjustmentType(data);
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Adj. Type",
					key: "delete_adjustment_type",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
